/// <amd-module name="SuiteCommerce.MapAndContactUs.Captcha.Configuration"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.MapAndContactUs.Captcha.Configuration", ["require", "exports", "SuiteCommerce.MapAndContactUs.Common.Configuration"], function (require, exports, Configuration_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.CaptchaConfiguration = void 0;
    var CaptchaConfiguration = /** @class */ (function (_super) {
        __extends(CaptchaConfiguration, _super);
        function CaptchaConfiguration() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Object.defineProperty(CaptchaConfiguration, "captchaConfiguration", {
            get: function () {
                var _a, _b;
                if (this._captchaConfiguration) {
                    return this._captchaConfiguration;
                }
                this._captchaConfiguration = {
                    challengeType: this.parseCaptchaChallengeId((_a = this.get('contactUsForm.captcha.captchaTypeOption')) !== null && _a !== void 0 ? _a : 'disabled'),
                    siteKey: (_b = this.get('contactUsForm.captcha.siteKey')) !== null && _b !== void 0 ? _b : ''
                };
                return this._captchaConfiguration;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(CaptchaConfiguration, "captchaChallengeType", {
            get: function () {
                return this.captchaConfiguration.challengeType;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(CaptchaConfiguration, "siteKey", {
            get: function () {
                var _a;
                return (_a = this.captchaConfiguration.siteKey) !== null && _a !== void 0 ? _a : '';
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(CaptchaConfiguration, "isCaptchaEnabled", {
            get: function () {
                return this.isGRecaptchaEnabled || this.isHCaptchaEnabled;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(CaptchaConfiguration, "isGRecaptchaEnabled", {
            get: function () {
                return this.captchaChallengeType === "g-recaptcha" /* GRECAPTCHA */;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(CaptchaConfiguration, "isHCaptchaEnabled", {
            get: function () {
                return this.captchaChallengeType === "h-captcha" /* HCAPTCHA */;
            },
            enumerable: false,
            configurable: true
        });
        CaptchaConfiguration.resetCaptcha = function () {
            switch (CaptchaConfiguration.captchaChallengeType) {
                case "g-recaptcha" /* GRECAPTCHA */:
                    break;
                case "h-captcha" /* HCAPTCHA */:
                    window.hcaptcha.render("h-captcha");
                    break;
            }
        };
        CaptchaConfiguration.parseCaptchaChallengeId = function (challengeId) {
            switch (challengeId.toLowerCase()) {
                case 'recaptcha':
                case 'g-recaptcha':
                    return "g-recaptcha" /* GRECAPTCHA */;
                case 'hcaptcha':
                case 'h-captcha':
                    return "h-captcha" /* HCAPTCHA */;
                case 'disabled':
                    return "disabled" /* DISABLED */;
                default: {
                    return "disabled" /* DISABLED */;
                }
            }
        };
        CaptchaConfiguration._captchaConfiguration = null;
        return CaptchaConfiguration;
    }(Configuration_1.Configuration));
    exports.CaptchaConfiguration = CaptchaConfiguration;
});
